module.exports = __webpack_public_path__ + "img/mobile scanner stand00.860b8132.jpg";